import lfApi, { AuthorizationError } from '@lf/api-client/lfApi';

export async function getChildProfiles() {
    try {
        const response = await lfApi.get('/user/child');
        if (response.status === 200) {
            return response.data.child_profiles;
        }
        else {
            console.error('Failed to fetch child profiles');
        }
    }
    catch (error) {
        console.error('Error fetching child profiles:', error);
    }

    return [];
}

export async function addChildProfile(childProfile) {
    try {
        const response = await lfApi.post('/user/child', childProfile);
        if (response.status === 200) {
            return response.data;
        }
        else {
            console.error('Failed to add child profile');
        }
    }
    catch (error) {
        console.error('Error adding child profile:', error);
        if (error.response && error.response.status === 403) {
            throw new AuthorizationError('Not authorized');
        }
    }

    return null;
}
